























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IPaymentStatus, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'paymentStatus',
  }),
  mixins: [paginationMixin],
})
export default class PaymentStatusList extends Vue {
  @Action('getEntities', { namespace: 'paymentStatus' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'paymentStatus' })
  entitiesSlice: IPaymentStatus[];
  @State('pageParams', { namespace: 'paymentStatus' })
  pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
  interval = null;
}
